import { render } from "./MesProjetAcademiques.vue?vue&type=template&id=38360890&scoped=true&ts=true"
import script from "./MesProjetAcademiques.vue?vue&type=script&lang=ts"
export * from "./MesProjetAcademiques.vue?vue&type=script&lang=ts"

import "./MesProjetAcademiques.vue?vue&type=style&index=0&id=38360890&scoped=true&lang=css"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38360890"]])

export default __exports__